import { Language } from '../enums/language.enum';
import { SupportedLocale } from '../enums/supported-locale.enum';
export const supportedLocaleToLanguage = {
    [SupportedLocale.ENGLISH]: Language.ENGLISH,
    [SupportedLocale.DANISH]: Language.DANISH,
    [SupportedLocale.GERMAN]: Language.GERMAN,
    [SupportedLocale.SPANISH_LATIN_AMERICAN]: Language.SPANISH_CASTILIAN,
    [SupportedLocale.FRENCH]: Language.FRENCH,
    [SupportedLocale.INDONESIAN]: Language.INDONESIAN,
    [SupportedLocale.ITALIAN]: Language.ITALIAN,
    [SupportedLocale.KOREAN]: Language.KOREAN,
    [SupportedLocale.MALAY]: Language.MALAY,
    [SupportedLocale.DUTCH]: Language.DUTCH_FLEMISH,
    [SupportedLocale.TURKISH]: Language.TURKISH,
    [SupportedLocale.CHINESE]: Language.ZULU,
    [SupportedLocale.CHINESE_TRADITIONAL]: Language.CHINESE,
    [SupportedLocale.HUNGARIAN]: Language.HUNGARIAN,
    [SupportedLocale.THAI]: Language.THAI,
    [SupportedLocale.PORTUGUESE_BRAZILIAN]: Language.PORTUGUESE,
    [SupportedLocale.POLISH]: Language.POLISH,
    [SupportedLocale.BULGARIAN]: Language.BULGARIAN,
    [SupportedLocale.SPANISH_EUROPEAN]: Language.SPANISH_CASTILIAN,
};
